<template>
  <div>
    Kassa
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CheckoutPage.vue?4f27848e